import ErrorHandled from './ErrorHandled.js';
import { IgnoredError, ReportError } from './errors.js';
import onErrorHandler from './onErrorHandler.js';
/**
 * Wrap a provided error handler handling some common cases (e.g. 401)
 *
 * @param callbacks map of status codes to error handling callbacks
 * @param errorHandler see type documentation
 *
 * @internal
 */
const buildErrorHandler = (callbacks, errorHandler) => (e) => {
    if (e instanceof IgnoredError) {
        return;
    }
    if (e instanceof ReportError) {
        const status = e.response.status;
        if (status !== undefined) {
            const callback = callbacks[status];
            if (callback !== undefined && callback() === ErrorHandled.Handled) {
                return;
            }
        }
    }
    onErrorHandler(errorHandler)(e);
};
export default buildErrorHandler;
//# sourceMappingURL=buildErrorHandler.js.map